import type { Point } from 'pixi.js';
import { Container, Sprite, Text } from 'pixi.js';
import { clamp } from '@softgames/math-utils';
import { cropSprite } from '../utils/cropSprite';
import type { DioramaPieceConfig } from '../../../app/state/diorama/dioramaState';

export class DioramaMaskView extends Container {
  private readonly sprite: Sprite;

  private readonly progressText: Text;

  constructor(private readonly config: DioramaPieceConfig) {
    super();

    this.sprite = new Sprite().props({
      parent: this,
      anchor: { x: 0.5, y: 0 },
      texture: config.texture,
      tint: 0x000000,
    });
    this.sprite.y = this.sprite.height * -0.5;

    this.progressText = new Text({ 
      text: '', 
      style: {
        fontFamily: 'Kanit',
        fontSize: 35,
        fill: 'white',
        stroke: { width: 4, color: 'black' },
      } })
      .props({
      anchor: 0.5,
      parent: this,
      x: config.labelOffset.x,
      y: config.labelOffset.y,
    });
  }

  public setProgress(value: number): this {
    const normProgress = clamp(value / this.config.price, 0, 1);
    this.progressText.text = `${Math.round(100 * normProgress)}%`;
    cropSprite(this.sprite, 1 - normProgress, 'height');
    return this;
  }

  public getParticleTarget(): Point {
    return this.progressText.getGlobalPosition();
  }
}
